import { usePage } from "@inertiajs/react";

interface SiteLinks {
    termsConditionsUrl: string;
    literacyPlanetLoginUrl: string;
    mathleticsLoginUrl: string;
}

const useSettingsPageProps = () => {
    return usePage().props as unknown as {
        recaptchaSiteKey: string;
        siteLinks: SiteLinks;
        eukaEmailAddress: string;
        versionText: string;
        appVersion: string;
        parentsNav: {
            id: number;
            route: string;
            name: string;
            isExternal: boolean;
        }[];
    };
};

export default useSettingsPageProps;
